// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.purchase-guide-slots-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
}

.page-header {
  margin-bottom: 2rem;
}
.page-header .back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: none;
  background: none;
  color: #5ea1d8;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-bottom: 1rem;
}
.page-header h1 {
  margin: 0 0 0.5rem;
  font-size: 2rem;
  color: #0f172a;
}
.page-header .subtitle {
  margin: 0;
  color: #64748b;
  max-width: 640px;
  line-height: 1.6;
}

.balance-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.balance-strip .balance-item .label {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #64748b;
}
.balance-strip .balance-item .value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
}

.checkout-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 2rem;
}

.pack-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 1rem;
}

.pack-card {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  text-align: left;
}
.pack-card.selected {
  border-color: #5ea1d8;
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35);
}
.pack-card .pack-name {
  font-weight: 700;
  color: #0f172a;
}
.pack-card .pack-guides {
  color: #5ea1d8;
  font-weight: 600;
}
.pack-card .pack-price {
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
}

.payment-panel .summary-card {
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  margin-bottom: 1rem;
}
.payment-panel .summary-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.35rem 0;
  color: #64748b;
}
.payment-panel .summary-row.total-row {
  margin-top: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e2e8f0;
  color: #0f172a;
  font-size: 1.05rem;
}
.payment-panel .summary-note {
  margin: 0.75rem 0 0;
  font-size: 0.85rem;
  color: #64748b;
}
.payment-panel .processing-note {
  margin-top: 0.75rem;
  color: #64748b;
  font-size: 0.9rem;
}

/* Dark mode — guide slot purchase checkout */
:host-context(body.theme-dark) .purchase-guide-slots-page {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .page-header .back-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .page-header h1 {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .page-header .subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .balance-strip {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .balance-strip .balance-item .label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .balance-strip .balance-item .value {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pack-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .pack-card.selected {
  border-color: #5ea1d8 !important;
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .pack-card .pack-name,
:host-context(body.theme-dark) .pack-card .pack-price {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pack-card .pack-guides {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .payment-panel .summary-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .payment-panel .summary-row {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .payment-panel .summary-row.total-row {
  color: #f8fafc !important;
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .payment-panel .summary-note,
:host-context(body.theme-dark) .payment-panel .processing-note {
  color: #94a3b8 !important;
}

@media (max-width: 900px) {
  .checkout-layout {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/purchase-guide-slots/purchase-guide-slots.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAMhB;EACE,iBAAA;EACA,cAAA;EACA,2BAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;AAME;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,cApBG;EAqBH,gBAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,eAAA;EACA,cA7BQ;AAwBZ;AAQE;EACE,SAAA;EACA,cAjCS;EAkCT,gBAAA;EACA,gBAAA;AANJ;;AAUA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAPF;AAUI;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAtDO;AA8Cb;AAWI;EACE,kBAAA;EACA,gBAAA;EACA,cA7DM;AAoDZ;;AAcA;EACE,aAAA;EACA,2CAAA;EACA,SAAA;AAXF;;AAcA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAXF;AAaE;EACE,qBA3FG;EA4FH,8CAAA;AAXJ;AAcE;EACE,gBAAA;EACA,cAhGQ;AAoFZ;AAeE;EACE,cArGG;EAsGH,gBAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,gBAAA;EACA,cA3GQ;AA6FZ;;AAmBE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,cA5HS;AA2Gb;AAmBI;EACE,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,cAnIM;EAoIN,kBAAA;AAjBN;AAqBE;EACE,mBAAA;EACA,kBAAA;EACA,cA1IS;AAuHb;AAsBE;EACE,mBAAA;EACA,cA/IS;EAgJT,iBAAA;AApBJ;;AAwBA,6CAAA;AAEE;EACE,yBAAA;AAtBJ;AA0BI;EACE,yBAAA;AAxBN;AA2BI;EACE,yBAAA;AAzBN;AA4BI;EACE,yBAAA;AA1BN;AA8BE;EACE,8BAAA;EACA,kDAAA;AA5BJ;AA+BM;EACE,yBAAA;AA7BR;AAgCM;EACE,yBAAA;AA9BR;AAmCE;EACE,8BAAA;EACA,kDAAA;AAjCJ;AAmCI;EACE,gCAAA;EACA,yDAAA;AAjCN;AAoCI;;EAEE,yBAAA;AAlCN;AAqCI;EACE,yBAAA;AAnCN;AAwCI;EACE,8BAAA;EACA,kDAAA;AAtCN;AAyCI;EACE,yBAAA;AAvCN;AAyCM;EACE,yBAAA;EACA,sDAAA;AAvCR;AA2CI;;EAEE,yBAAA;AAzCN;;AA8CA;EACE;IACE,0BAAA;EA3CF;AACF","sourcesContent":["$pink: #e83e8c;\n$blue: #5ea1d8;\n$text-dark: #0f172a;\n$text-light: #64748b;\n$border: #e2e8f0;\n\n.purchase-guide-slots-page {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 2.5rem 1.5rem 4rem;\n}\n\n.page-header {\n  margin-bottom: 2rem;\n\n  .back-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    border: none;\n    background: none;\n    color: $blue;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 0;\n    margin-bottom: 1rem;\n  }\n\n  h1 {\n    margin: 0 0 0.5rem;\n    font-size: 2rem;\n    color: $text-dark;\n  }\n\n  .subtitle {\n    margin: 0;\n    color: $text-light;\n    max-width: 640px;\n    line-height: 1.6;\n  }\n}\n\n.balance-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  padding: 1rem 1.25rem;\n  border-radius: 12px;\n  background: #f8fafc;\n  border: 1px solid $border;\n\n  .balance-item {\n    .label {\n      display: block;\n      font-size: 0.75rem;\n      text-transform: uppercase;\n      color: $text-light;\n    }\n\n    .value {\n      font-size: 1.35rem;\n      font-weight: 700;\n      color: $text-dark;\n    }\n  }\n}\n\n.checkout-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 2rem;\n}\n\n.pack-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 1rem;\n}\n\n.pack-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 1rem;\n  border-radius: 12px;\n  border: 1px solid $border;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n\n  &.selected {\n    border-color: $blue;\n    box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35);\n  }\n\n  .pack-name {\n    font-weight: 700;\n    color: $text-dark;\n  }\n\n  .pack-guides {\n    color: $blue;\n    font-weight: 600;\n  }\n\n  .pack-price {\n    font-size: 1.15rem;\n    font-weight: 700;\n    color: $text-dark;\n  }\n}\n\n.payment-panel {\n  .summary-card {\n    padding: 1rem;\n    border-radius: 12px;\n    border: 1px solid $border;\n    background: #fff;\n    margin-bottom: 1rem;\n  }\n\n  .summary-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n    padding: 0.35rem 0;\n    color: $text-light;\n\n    &.total-row {\n      margin-top: 0.5rem;\n      padding-top: 0.75rem;\n      border-top: 1px solid $border;\n      color: $text-dark;\n      font-size: 1.05rem;\n    }\n  }\n\n  .summary-note {\n    margin: 0.75rem 0 0;\n    font-size: 0.85rem;\n    color: $text-light;\n  }\n\n  .processing-note {\n    margin-top: 0.75rem;\n    color: $text-light;\n    font-size: 0.9rem;\n  }\n}\n\n/* Dark mode — guide slot purchase checkout */\n:host-context(body.theme-dark) {\n  .purchase-guide-slots-page {\n    color: #e2e8f0 !important;\n  }\n\n  .page-header {\n    .back-link {\n      color: #93c5fd !important;\n    }\n\n    h1 {\n      color: #f8fafc !important;\n    }\n\n    .subtitle {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .balance-strip {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    .balance-item {\n      .label {\n        color: #94a3b8 !important;\n      }\n\n      .value {\n        color: #f8fafc !important;\n      }\n    }\n  }\n\n  .pack-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    &.selected {\n      border-color: $blue !important;\n      box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35) !important;\n    }\n\n    .pack-name,\n    .pack-price {\n      color: #f8fafc !important;\n    }\n\n    .pack-guides {\n      color: #93c5fd !important;\n    }\n  }\n\n  .payment-panel {\n    .summary-card {\n      background: #111827 !important;\n      border-color: rgba(148, 163, 184, 0.28) !important;\n    }\n\n    .summary-row {\n      color: #94a3b8 !important;\n\n      &.total-row {\n        color: #f8fafc !important;\n        border-top-color: rgba(148, 163, 184, 0.28) !important;\n      }\n    }\n\n    .summary-note,\n    .processing-note {\n      color: #94a3b8 !important;\n    }\n  }\n}\n\n@media (max-width: 900px) {\n  .checkout-layout {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
